var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95703 1.36719L9.32422 0V4.10156H5.22266L7.10938 2.21484C6.41667 1.52214 5.59635 1.17578 4.64844 1.17578C3.68229 1.17578 2.85286 1.52214 2.16016 2.21484C1.48568 2.88932 1.14844 3.70964 1.14844 4.67578C1.14844 5.64193 1.48568 6.47135 2.16016 7.16406C2.85286 7.83854 3.68229 8.17578 4.64844 8.17578C5.32292 8.17578 5.97917 7.94792 6.61719 7.49219C7.27344 7.03646 7.72005 6.48958 7.95703 5.85156H9.16016C8.90495 6.8724 8.35807 7.71094 7.51953 8.36719C6.68099 9.02344 5.72396 9.35156 4.64844 9.35156C3.3724 9.35156 2.27865 8.89583 1.36719 7.98438C0.455729 7.07292 0 5.97005 0 4.67578C0 3.38151 0.455729 2.27865 1.36719 1.36719C2.27865 0.455729 3.3724 0 4.64844 0C5.19531 0 5.78776 0.136719 6.42578 0.410156C7.08203 0.665365 7.59245 0.984375 7.95703 1.36719Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.e11f7b1a30ef204bbf0e600a6ed36da9.svg";
export { ForwardRef as ReactComponent };